import { axiosHelper, POST_METHOD, PATCH_METHOD, GET_METHOD, DELETE_METHOD } from './helper'
import { ProfileNamePayload, UnlinkProviderPayload, ChangeEmailRequest, ChangeEmailPayload } from './type'

export function profile(accessToken: string) {
  return axiosHelper(GET_METHOD, `/user/profile`, null)
}

export function changePassword(accessToken: string, password: any) {
  return axiosHelper(PATCH_METHOD, `/profile/password`, password)
}

export function changeDisplayName(displayName: any) {
  const profileName: ProfileNamePayload = {
    profile_name: displayName
  }
  return axiosHelper(PATCH_METHOD, `/profile/name`, profileName)
}

export function unlinkProvider(provider: any) {
  const unlink: UnlinkProviderPayload = {
    provider: provider
  }
  return axiosHelper(PATCH_METHOD, `/user/provider/unlink`, unlink)
}

export function createPassword(password: any) {
  return axiosHelper(POST_METHOD, `/profile/password`, password)
}

export function uploadProfileImage(form: any) {
  return axiosHelper(PATCH_METHOD, `/profile/profile-picture`, form)
}

export function deleteProfileImage() {
  return axiosHelper(DELETE_METHOD, `/profile/profile-picture`, null)
}

export function changeEmailRequest(email: ChangeEmailRequest) {
  return axiosHelper(POST_METHOD, `/user/request-email-change`, email)
}

export function changeEmail(payload: ChangeEmailPayload) {
  return axiosHelper(POST_METHOD, '/user/change-email', payload)
}

export function cancelChangeEmail() {
  return axiosHelper(POST_METHOD, '/user/cancel-email-change', null)
}
